export const katarzynaLietz = {
    'meta': {
        'title': 'Psycholog, Psychoterapeuta Katarzyna Lietz • Centrum COLLIGO',
        'description': 'Jestem psychologiem oraz psychoterapeutą psychodynamicznym w trakcie szkolenia. Ukończyłam 5-letnie studia z psychologii, o specjalności psychologia kliniczna.'
    },
    'url': {
        'address': '/torun/zespol/psycholog-katarzyna-lietz/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/katarzyna-lietz.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psycholog, Psychoterapeuta psychodynamiczny'
        }
    }
}